// import external dependencies
import 'jquery';

// Import everything from autoload
import 'bootstrap';
import 'jquery-viewport-checker/src/jquery.viewportchecker';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import people from './routes/people';
import education from './routes/education';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // People template
  people,
  // Education template
  education,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

window.loadEventsList = function (append, container, past, terms = '') {
  if (container == null || typeof container == 'undefined') {
    container = '#events-list-container';
  }

  var loadMoreBtn = $(container).parents('.events-container').find('.load-more');

  if (append == null || append == undefined) {
    append = true;
  }

  if (terms == null || terms == undefined) {
    terms = '';
  }

  if (past == null || past == undefined) {
    past = false;
  }

  let page = loadMoreBtn.data('page');
  if (isNaN(page) || page < 1) {
    page = 1;
  }

  window.showSpinner();
  $.ajax({
    url: ajax_object.ajax_url,
    method: 'get',
    data: {
      action: 'load_events_list',
      terms: terms,
      paged: page,
      load_past: past ? 1 : 0
    },
    success: function(response, textStatus, request) {
      // var container = '#events-list-container';
      var loadMoreBtn = $(container).parents('.events-container').find('.load-more');
      let nextPageNum = parseInt(response.headers['X-WP-Current']);
      nextPageNum++;

      if (nextPageNum > parseInt(response.headers['X-WP-TotalPages'])) {
        loadMoreBtn.hide();
      } else {
        loadMoreBtn.show();
        loadMoreBtn.data('page', nextPageNum);
      }

      if (!append && response.data !== '') {
        $(container).html('');
      }

      if (response.data !== '') {
        $(container).append(response.data);
      }

      window.hideSpinner();
    }
  });
}

$(document).on('click', '.load-more', function(e) {
  e.preventDefault();
  window.loadEventsList(true, $(this).data('rel'), $(this).data('past') > 0 ? true : false, $(this).data('term'));
});

window.showSpinner = function()
{
  $('#loading').show();
}

window.hideSpinner = function()
{
  $('#loading').hide();
}



// WEBPACK FOOTER //
// ./scripts/main.js